export enum AccountTypeEnum {
    Active = 0,
    Passive = 1,
    ActivePassive = 2,
}
